/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * search_service
 * OpenAPI spec version: 0.1.0
 */

/**
 * Sort key for channel content search results.
 */
export type ChannelSortTimestamp =
  (typeof ChannelSortTimestamp)[keyof typeof ChannelSortTimestamp];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ChannelSortTimestamp = {
  message: 'message',
  thread: 'thread',
} as const;
